/**
 * agentRecipe — susun jawapan MENTAH custom GPT pelanggan ("Agent Saya", PRO Studio)
 * menjadi struktur `prompts` yang dibaca automation Flow.
 *
 * ⭐ INI LALUAN TANPA-AI. Semasa Configure, AI SESAAT mengenal pasti tajuk dalam
 *    jawapan agent dan pelanggan mengesahkannya — hasilnya disimpan sebagai "resipi"
 *    (agent.sources + field.source). Semasa larian sebenar kita cuma MEMOTONG teks
 *    ikut resipi itu. Jadi 100 produk = 0 panggilan AI = 0 kos.
 *
 * Dua mod:
 *   JSON  — jawapan boleh di-JSON.parse (selepas buang pagar ```), kunci dipadan
 *           dengan nama sumber. Nilai dikumpul mengikut turutan lawatan.
 *   TEKS  — jawapan markdown/prosa biasa. Setiap kemunculan tajuk menjadi penanda;
 *           nilainya ialah teks sehingga tajuk berikutnya — KECUALI tajuk yang terus
 *           diikuti KOTAK COPY: nilainya ialah seluruh isi kotak (lihat cariKotakKod).
 *
 * Pengagihan (peraturan yang boleh diramal):
 *   field "setiap babak"  → kemunculan ke-k: set = floor(k / babak) + 1
 *                                            babak = (k % babak) + 1
 *   field "setiap set"    → kemunculan ke-k: set = k + 1
 *   Jika hanya SATU kemunculan sedangkan set > 1, nilai itu digunakan untuk SEMUA
 *   set (kes biasa: satu caption dikongsi) — lebih berguna daripada set kosong.
 */

/* Had panjang SATU nilai blok. Dinaikkan 8,000 → 20,000 pada 2026-09-13: prompt
   video sebenar pelanggan (10,065 aksara, dalam kotak copy ChatGPT) terpotong
   SENYAP pada 8,000 — bahagian hujung prompt itu hilang tanpa sebarang amaran.
   Diukur pada kotak prompt flow.google.com (execCommand insertText, cara skrip
   Flow menampal): 20,558 aksara masuk penuh (~2 s), 40,004 aksara penuh (~7 s).
   ⚠️ Had pelayan Flow SEMASA MENJANA belum diuji (perlu membakar kredit).
   Nilai yang melebihi had kini DILAPOR (applyRecipe → terpotong), bukan senyap. */
const MAX_VALUE_CHARS = 20000;
/* Medan bertemplat boleh menggabung beberapa blok. Dulu MAX_VALUE_CHARS × 3
   (24,000). Kini dihadkan pada panjang yang DIUKUR masih diterima kotak Flow. */
const MAX_TEMPLATE_CHARS = 40000;

/** Buang pagar kod markdown dan cuba JSON.parse. null jika bukan JSON. */
function tryParseJson(raw) {
    const t = String(raw || '').trim();
    const s = t.indexOf('{');
    const e = t.lastIndexOf('}');
    if (s === -1 || e === -1 || e <= s) return null;
    const candidate = t.slice(s, e + 1).replace(/```json/gi, '').replace(/```/g, '').trim();
    try {
        const parsed = JSON.parse(candidate);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}

/**
 * Nyahescape urutan JSON dalam jawapan agent yang berbentuk JSON tetapi TAK SAH
 * (petik-dalam-petik tak di-escape → JSON.parse gagal → escape kekal sebagai
 * teks literal `\n`, `\"`). Menukarnya kepada baris/petik SEBENAR supaya:
 *   · kotak "jawapan" dalam Configure senang dibaca + diserlah (arahan user
 *     2026-08-20), dan
 *   · nilai yang dipotong keluar bersih (baris betul, bukan `\n` literal).
 * ⭐ DIEKSPORT — dipakai di UI (shownRaw) DAN larian sebenar (WorkspaceView)
 *   supaya paparan, serlahan, dan output SEMUA sepadan.
 * ⛔ Hanya jawapan berbentuk JSON (ada corak kunci `"x":`) diproses — teks biasa
 *   dibiar supaya laluan seperti `C:\nama` atau regex `\d` tidak termangle.
 *   Laluan tunggal kiri→kanan: `\\n` (backslash di-escape + n) kekal `\n` literal,
 *   bukan bertukar jadi baris — sama seperti JSON.parse.
 */
export function bersihJawapan(raw) {
    const s = String(raw || '');
    if (!/"[\w-]+"\s*:/.test(s)) return s;
    return s.replace(/\\(["\\/nrt])/g, (m, c) =>
        ({ '"': '"', '\\': '\\', '/': '/', n: '\n', r: '\r', t: '\t' }[c] || m));
}

const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

/**
 * Slug boleh-baca untuk token @ dalam composer template (cth "OMNI VIDEO PROMPT"
 * → "omni_video_prompt"). ⭐ DIEKSPORT + dipakai composer di ProStudioAgentSection
 * supaya slug yang user selit == slug yang enjin selesaikan. Jangan ubah formula
 * di satu tempat sahaja — kalau tidak token yang tersimpan berhenti padan senyap.
 */
export function slugifySource(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

/**
 * Kod @ bagi SETIAP blok, dijamin UNIK.
 *
 * ⚠️ KENAPA INI WUJUD (jangan pulangkan kepada slugifySource terus):
 * "HOOK:" dan "Hook:" kedua-duanya menjadi "hook" — tetapi dalam jawapan
 * sebenar ia dua benda BERLAINAN (tajuk set lawan baris dialog "0-2s Hook:").
 * Pelanggan memang perlu kedua-duanya sebagai blok berasingan. Dengan satu
 * kod dikongsi, enjin hanya boleh menyimpan SATU makna (yang terakhir menang)
 * dan blok kedua membayangi yang pertama secara senyap.
 *
 * ⛔ TURUTAN PENTING: blok yang datang DAHULU mengekalkan kod asasnya, yang
 * kemudian mendapat nombor (hook, hook2, hook3). semuaSumber() memulangkan
 * blok dikesan-AI dahulu, jadi templat medan yang sudah tersimpan (@hooktext)
 * tidak bertukar makna apabila pelanggan menambah blok baharu.
 */
export function petaSlug(sources) {
    const kodBagiSumber = {};   // teks blok  -> kod @
    const sumberBagiKod = {};   // kod @      -> teks blok
    for (const s of (sources || [])) {
        const asas = slugifySource(s);
        if (!asas) continue;
        if (kodBagiSumber[s] !== undefined) continue;   // teks sama, sudah diberi kod
        let kod = asas;
        let n = 2;
        while (sumberBagiKod[kod] !== undefined) { kod = asas + n; n += 1; }
        sumberBagiKod[kod] = s;
        kodBagiSumber[s] = kod;
    }
    return { kodBagiSumber, sumberBagiKod };
}
const asText = (v) => {
    if (v == null) return '';
    if (typeof v === 'string') return v.trim();
    if (typeof v === 'number' || typeof v === 'boolean') return String(v);
    if (Array.isArray(v)) return v.map(asText).filter(Boolean).join('\n');
    try { return JSON.stringify(v, null, 2); } catch { return ''; }
};

/**
 * Alias untuk satu tajuk — supaya resipi yang dipelajari daripada jawapan TEKS
 * masih boleh padan bila agent membalas JSON pada larian berikutnya.
 * "IMAGE DESCRIPTION — SCENE 1:" → ["imagedescriptionscene1", "imagedescription"]
 */
function aliasesFor(src) {
    const full = norm(src);
    const head = norm(String(src || '').split(/[—–\-:(]/)[0]);
    return head && head !== full && head.length >= 4 ? [full, head] : [full];
}

/* Potong nilai pada had dan REKOD nama bloknya — supaya pemotongan boleh
   dilaporkan kepada pelanggan, bukan berlaku senyap. `terpotong` = Set pilihan. */
function hadNilai(v, sumber, terpotong) {
    const s = String(v || '');
    if (s.length <= MAX_VALUE_CHARS) return s;
    if (terpotong) terpotong.add(sumber);
    return s.slice(0, MAX_VALUE_CHARS);
}

/* ══════════════════════════════════════════════════════════════════
   KOTAK COPY (code block) — 2026-09-13
   ══════════════════════════════════════════════════════════════════
   ⭐ Kenapa wujud (aduan user): GPT/Gem pelanggan meletakkan prompt panjang
      dalam kotak copy, dan prompt itu membawa TAJUK KECILNYA sendiri
      (PRODUCT IDENTITY LOCK:, LAYOUT:, FRAME 1 …). AI Configure mengira tajuk
      kecil itu sebagai blok, jadi "Step 3 — Storyboard Image Generation Prompt"
      berhenti pada tajuk kecil yang pertama — diukur 156 daripada 5,136 aksara.
      Butang copy ChatGPT/Gemini pula menyalin SELURUH kotak. Enjin kini
      mengikut butang copy itu.

   ⚠️⚠️ KEMBAR KONTRAK — pagar ``` di sini DITULIS oleh extension
      — skrip remote ChatGPT (src/chrome/chatgpt-automation.js, sejak 2026-09-26) DAN
      Gemini (src/chrome/gemini-automation.js, sejak 2026-09-27; ZIP 3.9.4 = kotakKodJawapan.ts).
      Blok @copy_box (SUMBER_KOTAK) juga membaca pagar ini. innerText ChatGPT dan
      Gemini TIDAK membawa pagar langsung; jawapan daripada extension lama tiada
      pagar, cariKotakKod() memulangkan [] dan enjin berkelakuan SEBIJI seperti
      sebelum ini (diukur: 0 daripada 399 jawapan tersimpan ada baris pagar).
      Ubah bentuk pagar di satu tempat = ubah di KEDUA-DUA.

   Peraturan pagar (ikut CommonMark): pembuka = baris ≥3 backtick (boleh ada
   label bahasa); penutup = baris backtick SAHAJA, sekurang-kurangnya sepanjang
   pembuka. Pembuka tanpa penutup (jawapan terpotong pada had panjang) → kotak
   berlanjutan sampai hujung teks. */
export function cariKotakKod(raw) {
    const text = String(raw || '');
    const out = [];
    const re = /^[ \t]*(`{3,})([^`\n]*)$/gm;
    let buka = null;
    let m;
    while ((m = re.exec(text))) {
        const awalBaris = m.index;
        const selepasBaris = Math.min(text.length, m.index + m[0].length + 1);   // termasuk \n
        if (!buka) {
            buka = { mula: awalBaris, isiMula: selepasBaris, n: m[1].length };
        } else if (m[1].length >= buka.n && !m[2].trim()) {
            out.push({ mula: buka.mula, isiMula: buka.isiMula, isiTamat: awalBaris, tamat: selepasBaris });
            buka = null;
        }
    }
    if (buka) out.push({ mula: buka.mula, isiMula: buka.isiMula, isiTamat: text.length, tamat: text.length });
    return out;
}

/* Potong teks [a, b) sambil membuang BARIS PAGAR kotak — pagar hanya penanda
   sempadan, ia tidak pernah sebahagian daripada jawapan pelanggan. */
function potongTanpaPagar(text, a, b, kotak) {
    const buang = [];
    for (const k of kotak) {
        buang.push([k.mula, k.isiMula]);
        if (k.tamat > k.isiTamat) buang.push([k.isiTamat, k.tamat]);
    }
    buang.sort((x, y) => x[0] - y[0]);
    let hasil = '';
    let dari = a;
    for (const [s, e] of buang) {
        if (e <= dari || s >= b) continue;
        if (s > dari) hasil += text.slice(dari, Math.min(s, b));
        dari = Math.max(dari, e);
    }
    if (dari < b) hasil += text.slice(dari, b);
    return hasil;
}

/** Kumpul nilai daripada objek JSON mengikut nama kunci (turutan lawatan). */
function collectFromJson(root, sources, terpotong = null) {
    const want = new Map();
    for (const s of sources) {
        for (const a of aliasesFor(s)) if (!want.has(a)) want.set(a, s);
    }
    const out = {};
    sources.forEach(s => { out[s] = []; });

    const walk = (node) => {
        if (!node || typeof node !== 'object') return;
        if (Array.isArray(node)) { node.forEach(walk); return; }
        for (const [k, v] of Object.entries(node)) {
            const hit = want.get(norm(k));
            if (hit) {
                const txt = hadNilai(asText(v), hit, terpotong);
                if (txt) out[hit].push(txt);
            }
            if (v && typeof v === 'object') walk(v);
        }
    };
    walk(root);
    return out;
}

/**
 * Senarai blok LENGKAP bagi satu agent: yang dikesan AI semasa Configure
 * (medan 'sources') DICAMPUR dengan yang dibuat sendiri oleh pelanggan
 * (medan 'customSources').
 *
 * ⭐ Kenapa DUA senarai, bukan satu: setiap larian Configure MENGGANTI
 *    'sources' dengan senarai baharu yang dikesan. Kalau blok buatan
 *    pelanggan disimpan di situ juga, ia terhapus setiap kali dia menekan
 *    Configure semula — kerja tangannya hilang tanpa amaran.
 *
 * ⛔ Gunakan fungsi INI di mana-mana sahaja senarai blok diperlukan. Membaca
 *    'agent.sources' terus akan terlepas blok buatan pelanggan, dan ia gagal
 *    SENYAP (medan dikira "tiada sumber" walaupun ia berpadan).
 */
export function semuaSumber(agent) {
    const auto = Array.isArray(agent?.sources) ? agent.sources : [];
    const sendiri = Array.isArray(agent?.customSources) ? agent.customSources : [];
    // SUMBER_KOTAK sentiasa TERAKHIR — blok sedia ada kekal dengan kod @ asalnya (petaSlug).
    return [...new Set([...auto, ...sendiri].map((s) => String(s || '').trim()).filter(Boolean)), SUMBER_KOTAK];
}

/* ══════════════════════════════════════════════════════════════════
   BLOK AUTOMATIK "Copy box" (@copy_box) — 2026-09-27, arahan user
   ══════════════════════════════════════════════════════════════════
   Nilai = SELURUH isi setiap kotak copy dalam jawapan (sama seperti butang
   Copy), mengikut turutan — kotak ke-k → set ke-k (peraturan valueForSource).
   ⭐ Kenapa: Gem/GPT yang membalas SATU kotak JSON tanpa tajuk di atasnya tiada
      cara untuk mengambil kotak itu bulat-bulat — mod JSON memecahkannya ikut
      kunci, dan peraturan "tajuk terus diikuti kotak" perlukan tajuk.
   ⛔ Blok SINTETIK: tidak disimpan dalam agent.sources/customSources, bukan
      tajuk (cariPenanda melangkaunya), dan hanya berisi bila jawapan ada pagar
      ``` (extension 3.9.4+ menulis pagar untuk ChatGPT + Gemini). */
export const SUMBER_KOTAK = 'Copy box';
export const KOD_SUMBER_KOTAK = slugifySource(SUMBER_KOTAK);   // 'copy_box'

function nilaiKotakCopy(raw, terpotong) {
    const text = String(raw || '');
    return cariKotakKod(text)
        .map((k) => text.slice(k.isiMula, k.isiTamat).trim())
        .filter(Boolean)
        .map((isi) => hadNilai(isi, SUMBER_KOTAK, terpotong));
}

/** Kumpul nilai daripada teks biasa/markdown mengikut tajuk.
    ⭐ DIEKSPORT supaya skrin "Blok anda sendiri" boleh memapar kiraan padanan
    + nilai pertama menggunakan enjin YANG SAMA — bukan salinan kedua yang
    boleh terpesong daripada tingkah laku larian sebenar. */
/**
 * Penanda tajuk yang BENAR-BENAR dipakai oleh enjin, mengikut turutan.
 * Dieksport supaya skrin boleh menyerlahkan kedudukan padanan pada teks
 * jawapan — serlahan yang dikira sendiri oleh UI akan menunjukkan tempat
 * yang enjin sebenarnya TIDAK guna, dan itu lebih mengelirukan daripada
 * tiada serlahan langsung.
 */
export function cariPenanda(raw, sources, utama = [], jangka = null) {
    // Tajuk yang MENANG bila dua tajuk bermula pada kedudukan yang sama.
    const setUtama = new Set(utama.map((x) => String(x || '').trim()));
    const text = String(raw || '');
    const lower = text.toLowerCase();
    const markers = [];

    /* Semua kedudukan bagi satu tajuk.
         peka          = huruf besar/kecil mesti TEPAT
         pangkalBaris  = tajuk mesti duduk di pangkal baris (hiasan markdown
                         seperti ** ## - > dibenarkan di hadapannya) */
    const cariSemua = (asal, peka, pangkalBaris) => {
        const jerami = peka ? text : lower;
        const needle = peka ? asal : asal.toLowerCase();
        const pos = [];
        let from = 0;
        for (;;) {
            const at = jerami.indexOf(needle, from);
            if (at === -1) break;
            from = at + needle.length;
            if (pangkalBaris) {
                let i = at - 1;
                while (i >= 0 && /[ \t#*>_-]/.test(text[i])) i -= 1;
                if (i >= 0 && text[i] !== '\n') continue;   // bukan pangkal baris
            }
            pos.push({ pos: at, len: needle.length });
        }
        return pos;
    };
    for (const src of sources) {
        const asal = String(src || '').trim();
        if (asal.length < 2) continue;
        // Pagar kotak copy (``` ) bukan tajuk — jangan sesekali jadikan penanda.
        if (/^`+$/.test(asal)) continue;
        // Blok sintetik "Copy box" bukan tajuk (lihat SUMBER_KOTAK).
        if (asal === SUMBER_KOTAK) continue;
        /* ⭐ BLOK BUATAN PELANGGAN = PADANAN PEKA HURUF BESAR/KECIL.
           Sebabnya datang daripada jawapan sebenar (aduan user 2026-08-20):
           tajuk set ditulis "HOOK:" manakala baris dialog ditulis "0-2s Hook:".
           Dengan padanan abai-huruf, blok "HOOK:" berpadan 6x pada agent yang
           hanya ada 3 set — enjin memberi kemunculan ke-k kepada set ke-k, jadi
           set 2 menerima teks DIALOG set 1, bukan hooknya sendiri.
           Pelanggan menyerlah teks itu sendiri daripada jawapan, jadi huruf
           besar/kecil yang dia serlah memang apa yang dia maksudkan.
           ⛔ Blok yang DIKESAN AI kekal abai-huruf: label itu datang daripada
           larian lain dan hurufnya boleh berbeza sedikit — menjadikannya peka
           huruf akan mematikan padanan agent sedia ada secara senyap. */
        const sendiri = setUtama.has(asal);
        let ketemu = cariSemua(asal, sendiri, false);

        /* ⭐ PADANAN KETAT SEBAGAI PENYELAMAT (2026-08-26) — blok DIKESAN AI sahaja.
           Aduan sebenar: tajuk set ditulis "HOOK:" tetapi baris dialog di dalam
           skrip video ditulis "0-2s Hook:". Dengan padanan abai-huruf, blok "HOOK:"
           berpadan 6× pada agent yang cuma ada 3 set — enjin lalu memberi hook set 2
           kepada teks DIALOG set 1, dan penanda sesat itu turut MEMOTONG nilai blok
           jirannya (Video Script babak 1 tinggal "0-2s").

           Peraturan: kalau bilangan padanan longgar TIDAK munasabah untuk bilangan
           set/babak agent ini, TETAPI padanan ketat (huruf tepat + pangkal baris)
           memberi bilangan yang munasabah — pakai yang ketat.

           ⛔ Blok yang bilangannya SUDAH munasabah tidak pernah disentuh. Itulah
           yang menjadikan pembetulan ini selamat untuk agent sedia ada: diukur pada
           82 agent pelanggan yang ada jawapan tersimpan, hanya 2 blok berubah dan
           kedua-duanya memang tersasar sebelum ini. `jangka` datang daripada
           jangkaanSumber() — satu formula, dikongsi enjin dan skrin. */
        if (!sendiri && Array.isArray(jangka && jangka[src]) && jangka[src].length
            && !jangka[src].includes(ketemu.length)) {
            const ketat = cariSemua(asal, true, true);
            if (jangka[src].includes(ketat.length)) ketemu = ketat;
        }

        for (const p of ketemu) {
            markers.push({ pos: p.pos, len: p.len, heading: src, utama: sendiri });
        }
    }

    // ⛔ BUANG TAJUK BERTINDIH — WAJIB, jangan hapuskan langkah ini.
    //   Tajuk sebenar pelanggan kerap bersarang, cth "SCENE 1:" ialah SEBAHAGIAN
    //   daripada "IMAGE DESCRIPTION — SCENE 1:". Tanpa penapisan ini, penanda
    //   pendek jatuh DI DALAM penanda panjang → titik tamat lebih awal daripada
    //   titik mula → nilai keluar KOSONG. (Bug sebenar 2026-08-05, akaun admin.)
    //   Susun ikut kedudukan; pada kedudukan sama, tajuk PALING PANJANG menang.
    /* ⚠️ TIGA aras, dan turutannya PENTING:
         1) kedudukan
         2) tajuk UTAMA (blok buatan pelanggan) menang
         3) barulah tajuk paling PANJANG menang

       Aras (2) ditambah 2026-08-20 selepas pepijat sebenar: pengesan AI
       menyimpan tajuk hook BERSAMA jawapannya (HOOK: "Patutlah waktu santai
       cari ni"). Tajuk itu bermula pada kedudukan yang SAMA dengan blok
       "HOOK:" yang dibuat pelanggan, dan kerana ia lebih panjang ia menang —
       lalu menelan blok pelanggan. Hasilnya: blok pelanggan melaporkan
       "tiada jumpa" walaupun perkataan itu jelas ada pada setiap set, DAN
       tajuk auto itu sendiri memulangkan kosong (nilainya berakhir serta-merta
       pada tajuk berikutnya). Diukur pada jawapan sebenar user: HOOK: = 0
       padanan sebelum pembetulan, 3 selepasnya.

       Blok buatan pelanggan diberi keutamaan kerana dia MEMANG menciptanya
       untuk menggantikan tajuk auto yang salah bentuk. */
    markers.sort((a, b) => (a.pos - b.pos) || (Number(b.utama) - Number(a.utama)) || (b.len - a.len));
    const kept = [];
    let coveredUntil = -1;
    for (const m of markers) {
        if (m.pos < coveredUntil) continue;   // bersarang dalam tajuk sebelumnya
        kept.push(m);
        coveredUntil = m.pos + m.len;
    }
    return kept;
}

/** Kumpul nilai daripada teks biasa/markdown mengikut tajuk.
    `terpotong` (Set, pilihan) menerima nama blok yang nilainya dipotong pada had. */
export function collectFromText(raw, sources, utama = [], jangka = null, terpotong = null) {
    const text = String(raw || '');
    const kept = cariPenanda(raw, sources, utama, jangka);
    const kotak = cariKotakKod(text);
    const kotakBagi = (pos) => kotak.find((k) => pos >= k.isiMula && pos < k.isiTamat) || null;

    const out = {};
    sources.forEach(s => { out[s] = []; });

    for (let i = 0; i < kept.length; i++) {
        const m = kept[i];
        const lepas = m.pos + m.len;
        let value;

        if (!kotak.length) {
            // ⛔ LALUAN ASAL — jawapan tanpa kotak copy. SEBIJI seperti sebelum
            //    2026-09-13; semua jawapan daripada extension lama melalui sini.
            const stop = i + 1 < kept.length ? kept[i + 1].pos : text.length;
            value = text.slice(lepas, stop);
        } else {
            /* ⭐ PERATURAN KOTAK COPY (lihat cariKotakKod):
                 1) Tajuk yang TERUS diikuti kotak copy → nilainya = isi kotak itu
                    SAHAJA, sama seperti butang copy. Tajuk kecil di dalam kotak tidak
                    memotongnya, dan sembang selepas kotak ("Would you like me to…")
                    tidak ikut masuk.
                 2) Tajuk DI DALAM kotak → berhenti pada tajuk berikutnya ATAU hujung
                    kotak, mana dahulu. (Blok seperti LAYOUT: kekal boleh dipakai.)
                 3) Tajuk DI LUAR kotak yang tidak terus diikuti kotak → tajuk di
                    dalam kotak tidak memotongnya; berhenti pada tajuk luar berikutnya.
               Baris pagar sentiasa dibuang daripada nilai. */
            const diDalam = kotakBagi(m.pos);
            let stop;
            if (diDalam) {
                stop = Math.min(i + 1 < kept.length ? kept[i + 1].pos : text.length, diDalam.isiTamat);
            } else {
                let j = i + 1;
                while (j < kept.length && kotakBagi(kept[j].pos)) j += 1;
                stop = j < kept.length ? kept[j].pos : text.length;
            }
            const kotakTerus = diDalam ? null : kotak.find((k) => k.mula >= lepas && k.mula < stop);
            if (kotakTerus && /^[\s*_:：\-–—>#]*$/.test(text.slice(lepas, kotakTerus.mula))) {
                /* Isi kotak dipulangkan BULAT-BULAT (hanya baris kosong di hujung
                   dibuang) — tiada pembersihan hiasan markdown, kerana kotak copy
                   memang menyimpan teks mentah (# atau - di pangkal ialah kandungan). */
                const isi = text.slice(kotakTerus.isiMula, kotakTerus.isiTamat).trim();
                if (isi) out[m.heading].push(hadNilai(isi, m.heading, terpotong));
                continue;
            }
            value = potongTanpaPagar(text, lepas, stop, kotak);
        }
        /* Agent yang membalas JSON tetapi dengan tanda petik DALAM nilai yang
           tidak di-escape (cth Video Script: 0-2s (Hook): "…") ialah JSON TAK SAH
           — JSON.parse gagal, jadi kita mendarat di laluan teks ini, bukan
           collectFromJson yang bersih. Potongan-ikut-tajuk meninggalkan bungkusan
           kunci→nilai JSON: `": "` di hadapan, dan di belakang SEMUA struktur JSON
           dari petik-tutup nilai hingga tajuk berikutnya (`",` · `"},` · malah
           `"},\n"set2":{` — potongan berhenti pada kunci SET seterusnya, jadi
           ekornya boleh mengandungi nama kunci itu).
           ⛔ Hanya buang bila `": "` MEMANG ada di hadapan (tanda JSON pasti).
              Agent yang membalas teks biasa tiada bentuk itu, jadi ia langsung
              TIDAK tersentuh — termasuk nilai yang berakhir dengan tanda petik
              biasa. Disahkan ujian (scratchpad/uji_bersih.mjs). Petik dialog DALAM
              ayat kekal kerana ia bukan petik-tutup di hujung. */
        const bungkusJson = value.match(/^\s*"?\s*:\s*"/);
        if (bungkusJson) {
            value = value.slice(bungkusJson[0].length).replace(/"\s*[,}\]][\s\S]*$/, '');
        }
        value = value
            // buang hiasan tajuk di hadapan nilai: ** : - — dan baris kosong
            .replace(/^[\s*_:：\-–—>#]+/, '')
            .replace(/[\s*_>#]+$/, '')
            .trim();
        value = hadNilai(value, m.heading, terpotong);
        if (value) out[m.heading].push(value);
    }
    return out;
}

/* ══════════════════════════════════════════════════════════════════
   BENTUK LARIAN — berapa set, berapa babak, dan medan mana yang
   berubah SETIAP BABAK berbanding sekali setiap SET.
   ══════════════════════════════════════════════════════════════════ */

/** Bilangan set + babak SEBENAR yang enjin akan isi. Satu formula sahaja. */
export function kiraSetBabak(agent) {
    const sceneCount = Math.max(1, Math.min(5, Number(agent?.sceneCount) || 1));   // had 5 babak — keputusan user 2026-08-18
    /* 1-2 babak → enjin sedia ada (AI8SAAT / AI16SAAT) menyimpan babak DI DALAM
       setiap set, jadi 1-3 set × 1-2 babak semuanya sah.
       3+ babak → enjin dinamik (asas FLOWNITY) memetakan BABAK kepada slot
       "set", jadi slot itu sudah terpakai dan hanya SATU persona muat.
       Sepadan dengan keputusan pemilik 19 Ogos: "5 babak = 1 persona". */
    const setCount = sceneCount > 2 ? 1 : Math.max(1, Math.min(3, Number(agent?.setCount) || 1));
    return { setCount, sceneCount };
}

/**
 * Adakah medan ini membawa nilai BERBEZA bagi setiap babak?
 *
 * ⭐ Jawapannya datang daripada KAD PRODUK sebenar, bukan daripada nama kumpulan
 *    'sceneFields'. Kad 2-babak menyimpan promptVideo1/2 + videoScript1/2, tetapi
 *    HANYA SATU promptImage — gambar dijana sekali, dan babak kedua ialah
 *    sambungan video daripada gambar yang sama. Maka:
 *        video + video script  → setiap BABAK
 *        gambar, hook, caption, medan teks lain → sekali setiap SET
 * ⛔ Jangan jadikan gambar per-babak tanpa menukar kad produk dahulu: kunci
 *    `promptImage2` yang pernah ditulis sebelum ini tidak pernah dibaca oleh
 *    sesiapa pun (disahkan pada laluan generate WorkspaceView).
 */
export function medanPerBabak(field, sceneCount) {
    if (!(Number(sceneCount) > 1)) return false;
    if (field?.role === 'video') return true;
    if (field?.role === 'image') return false;
    const l = norm(field?.label);
    return l.includes('script') || l.includes('skrip') || l.includes('narration');
}

/**
 * Templat yang dipakai oleh satu babak.
 *   field.scenes[n-1] = susunan KHAS babak ke-n (dipilih pelanggan di Configure)
 *   tiada             → warisi susunan babak 1 (field.template)
 *   tiada juga        → null, bermakna guna field.source cara lama
 * ⛔ Warisan itu sengaja: agent lama tiada `scenes` langsung, jadi setiap babak
 *    mesti terus berkelakuan seperti sebelum ini.
 */
export function templatMedan(field, scene) {
    const arr = Array.isArray(field?.scenes) ? field.scenes : null;
    const khas = arr ? arr[Math.max(1, Number(scene) || 1) - 1] : null;
    if (typeof khas === 'string') return khas;
    return typeof field?.template === 'string' ? field.template : null;
}

/**
 * Berapa kali setiap blok SEPATUTNYA muncul dalam jawapan, mengikut medan yang
 * memakainya. Dipakai oleh cariPenanda untuk memutuskan sama ada bilangan
 * padanan longgar itu munasabah — lihat nota panjang di sana.
 * ⭐ SATU formula, dikongsi enjin dan skrin Configure.
 */
export function jangkaanSumber(agent) {
    const { setCount, sceneCount } = kiraSetBabak(agent);
    const perSet = [1, setCount];
    const perBabak = [1, setCount, setCount * sceneCount];
    const { sumberBagiKod } = petaSlug(semuaSumber(agent));
    const out = {};
    const tambah = (src, senarai) => {
        if (!src) return;
        out[src] = [...new Set([...(out[src] || []), ...senarai])];
    };
    const kutip = (f, senarai) => {
        tambah(f && f.source, senarai);
        for (let s = 1; s <= sceneCount; s += 1) {
            const tpl = templatMedan(f, s);
            if (typeof tpl !== 'string') continue;
            for (const m of tpl.matchAll(/@([a-zA-Z0-9_]+)/g)) {
                tambah(sumberBagiKod[m[1].toLowerCase()], senarai);
            }
        }
    };
    for (const f of (agent?.sceneFields || [])) {
        kutip(f, medanPerBabak(f, sceneCount) ? perBabak : perSet);
    }
    for (const f of (agent?.setFields || [])) kutip(f, perSet);
    return out;
}

/** Kunci sasaran dalam objek set, mengikut peranan field + bilangan babak. */
export function targetKey(field, scene, sceneCount) {
    const multi = sceneCount > 1;
    /* ⚠️ Gambar babak PERTAMA ditulis sebagai `promptImage` (tanpa nombor).
       Itu nama yang enjin 1-babak DAN 2-babak sedia ada baca. Babak kedua
       dan seterusnya kekal bernombor — enjin hari ini mengabaikannya, enjin
       dinamik kelak menggunakannya. Lihat juga targetKeyKedua(). */
    if (field.role === 'image') return (multi && scene > 1) ? `promptImage${scene}` : 'promptImage';
    if (field.role === 'video') return multi ? `promptVideo${scene}` : 'promptVideo';

    const l = norm(field.label);
    if (l.includes('caption')) return 'captionTiktok';
    if (l.includes('script') || l.includes('narration') || l.includes('skrip')) {
        return multi ? `videoScript${scene}` : 'videoScript';
    }
    // ⭐ 'hookText' (BUKAN 'hook') — nama slot yang kad workspace baca & auto-sync
    //    ke Image Prompt. Disahkan berfungsi via ujian sync 2026-08-19.
    if (l.includes('hook')) return 'hookText';
    // Field ciptaan pelanggan — disimpan dengan kunci selamat supaya tidak hilang.
    // ⚠️ Kad produk belum memaparkan field jenis ini (kerja akan datang).
    const slug = String(field.label || 'field').replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_|_$/g, '');
    return `custom_${slug || 'field'}`;
}

/**
 * Nilai SETIAP blok bagi satu jawapan — laluan JSON atau TEKS dipilih di sini.
 * ⭐ DIEKSPORT supaya skrin Configure memapar kiraan yang SAMA seperti larian
 *    sebenar. Sebelum ini skrin memanggil collectFromText terus, jadi agent yang
 *    membalas JSON sentiasa memapar "0 kali" pada setiap blok walaupun padanan
 *    sebenarnya berjaya.
 */
export function kumpulNilai(rawText, agent, terpotong = null) {
    // Blok sintetik "Copy box" dikira berasingan — ia bukan tajuk / kunci JSON.
    const sources = semuaSumber(agent).filter((s) => s !== SUMBER_KOTAK);
    const json = tryParseJson(rawText);
    const out = !sources.length ? {} : json
        ? collectFromJson(json, sources, terpotong)
        : collectFromText(rawText, sources, agent?.customSources || [], jangkaanSumber(agent), terpotong);
    out[SUMBER_KOTAK] = nilaiKotakCopy(rawText, terpotong);
    return out;
}

/**
 * @param {string} rawText  jawapan mentah pusingan yang dipilih
 * @param {object} agent    { sources, sceneFields, setFields, setCount, sceneCount, output }
 * @returns {{prompts: object, filled: number, missing: string[], mode: 'json'|'text', terpotong: string[]}}
 *          terpotong = label medan yang nilainya dipotong pada had panjang (untuk dilapor).
 */
export function applyRecipe(rawText, agent) {
    // Blok yang dikesan AI + blok buatan pelanggan (lihat semuaSumber).
    const sources = semuaSumber(agent);
    const { setCount, sceneCount } = kiraSetBabak(agent);

    const mode = tryParseJson(rawText) ? 'json' : 'text';
    const potongSumber = new Set();
    const values = kumpulNilai(rawText, agent, potongSumber);
    const terpotong = new Set();   // label medan yang nilainya dipotong pada had

    const prompts = {};
    const missing = [];
    let filled = 0;

    const put = (setNo, key, val) => {
        if (!val) return;
        const sk = `set${setNo}`;
        if (!prompts[sk]) prompts[sk] = {};
        prompts[sk][key] = val;
        filled++;
    };

    // ── Composer template (Fasa 1) — satu field boleh GABUNG beberapa blok Gem
    //    melalui token @slug + teks biasa (cth video prompt + dialog di bawahnya).
    //    Field TANPA template (null/tiada) kekal guna laluan SUMBER-TUNGGAL lama —
    //    jadi agent sedia ada tidak berubah walau satu aksara. ──
    const slugToSource = petaSlug(sources).sumberBagiKod;

    /* ⭐⭐ KEMUNCULAN MANA YANG DIPAKAI — dibaiki 2026-08-26.
       Peraturan LAMA menganggap setiap blok berulang sekali bagi setiap
       (set × babak). Itu betul untuk agent 1-babak, tetapi SALAH untuk agent
       berbilang babak yang menulis satu TAJUK BERASINGAN bagi setiap babak
       (bentuk paling biasa: "VIDEO DESCRIPTION (SCENE 1)" dan "(SCENE 2)",
       setiap satu muncul sekali sahaja per set).

       Diukur pada jawapan sebenar pelanggan (3 set × 2 babak): dengan peraturan
       lama, set 2 menerima gambar+video milik SET 3, dan set 3 langsung tidak
       menerima apa-apa — Run Flow menghasilkan kosong tanpa sebarang amaran.

       Peraturan BAHARU membaca bilangan kemunculan sebenar:
         1 kemunculan                     → dikongsi semua set (seperti dahulu)
         setCount × sceneCount ke atas    → blok berulang setiap BABAK
         selain itu (lazimnya = setCount) → blok berulang sekali setiap SET
       ⛔ Bagi agent 1-babak, perSlot === setCount, jadi cabang "ikut babak"
          tidak pernah aktif dan hasilnya SEBIJI seperti sebelum ini. */
    const perSlot = setCount * sceneCount;
    const valueForSource = (src, setNo, scene, perBabak) => {
        const arr = values[src] || [];
        if (!arr.length) return '';
        if (arr.length === 1) return arr[0];
        const ikutBabak = perSlot > setCount && arr.length >= perSlot;
        const idx = ikutBabak
            ? ((setNo - 1) * sceneCount) + ((perBabak ? scene : 1) - 1)
            : (setNo - 1);
        return arr[idx] || '';
    };

    const resolveField = (f, setNo, scene, perBabak) => {
        const tpl = templatMedan(f, scene);
        if (typeof tpl === 'string') {       // '' pun = user dah susun sendiri
            const gabung = String(tpl)
                .replace(/@([a-zA-Z0-9_]+)/g, (_m, slug) => {
                    const src = slugToSource[slug.toLowerCase()];
                    if (!src) return '';   // token tak dikenali → dibuang (elak bocor ke prompt)
                    const v = valueForSource(src, setNo, scene, perBabak);
                    if (v && potongSumber.has(src)) terpotong.add(f.label);
                    return v;
                })
                .trim();
            if (gabung.length > MAX_TEMPLATE_CHARS) terpotong.add(f.label);
            return gabung.slice(0, MAX_TEMPLATE_CHARS);
        }
        const v = f?.source ? valueForSource(f.source, setNo, scene, perBabak) : '';
        if (v && potongSumber.has(f.source)) terpotong.add(f.label);
        return v;
    };

    /* Cukup SATU babak yang ada isi untuk medan ini dikira "berpadan" — babak
       yang tinggal kosong tidak sepatutnya menjatuhkan seluruh medan ke dalam
       senarai `missing` (skrin akan menandakan babak itu sendiri). */
    const fieldHasContent = (f, perBabak) => {
        const babak = perBabak ? sceneCount : 1;
        for (let s = 1; s <= babak; s += 1) {
            const tpl = templatMedan(f, s);
            if (typeof tpl === 'string') {
                if (resolveField(f, 1, s, perBabak)) return true;
            } else if (f?.source && (values[f.source] || []).length) {
                return true;
            }
        }
        return false;
    };

    // ── Field kumpulan 'sceneFields' (gambar · video · video script) ──
    const sceneFields = (agent?.sceneFields || []).filter(f =>
        !(f.role === 'video' && agent?.output === 'image')
    );
    for (const f of sceneFields) {
        const perBabak = medanPerBabak(f, sceneCount);
        if (!fieldHasContent(f, perBabak)) { missing.push(f.label); continue; }
        const babak = perBabak ? sceneCount : 1;
        for (let setNo = 1; setNo <= setCount; setNo += 1) {
            for (let scene = 1; scene <= babak; scene += 1) {
                put(setNo, targetKey(f, scene, perBabak ? sceneCount : 1), resolveField(f, setNo, scene, perBabak));
            }
            /* Salinan bernombor bagi gambar. Enjin sedia ada membaca
               `promptImage`; enjin dinamik kelak membaca `promptImage1`.
               Nilainya SAMA — gambar satu sahaja bagi setiap set. */
            if (f.role === 'image' && sceneCount > 1) {
                put(setNo, 'promptImage1', resolveField(f, setNo, 1, false));
            }
        }
    }

    // ── Field "sekali setiap set" (hook · caption) ──
    for (const f of (agent?.setFields || [])) {
        if (!fieldHasContent(f, false)) { missing.push(f.label); continue; }
        for (let s = 1; s <= setCount; s += 1) {
            put(s, targetKey(f, 1, sceneCount), resolveField(f, s, 1, false));
        }
    }

    return { prompts, filled, missing, mode, terpotong: [...terpotong].filter(Boolean) };
}
export default applyRecipe;
